module.exports = __webpack_public_path__ + "img/35.ec18ec41.png";